import { consumerTypes, accountTypes } from '../../flows/shared/utils';

export const displayAddress = (address = {}) => {
  const { street1, street2, country, zip, state, city } = address;
  return [street1, street2, city, state, country, zip]
    .filter(Boolean)
    .join(' ');
};

export const shouldDisplayCancelorCloseBtn = (consumerName, accountType) => {
  return (
    consumerName !== consumerTypes.FONASU &&
    ![accountTypes.JOINT].includes(accountType) &&
    ![accountTypes.UGMAUTMA].includes(accountType)
  );
};
